export const MUNILY_INPUT_PREVIEW_DEFAULTS = {
  value: '',
  label: '',
  valuePrefix: '',
  valueSuffix: '',
  showLabel: true,
  showLeadingIcon: true,
  leadingIcon: 'person',
  showEditIcon: true,
  borderless: false,
  clickable: false,
} as const;
